import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as moment from "moment";
import * as _ from "lodash";
import {BillingOrderService} from "../../../billing-accounts/services/billing-order.service";
import {FulfillmentLineType} from "../../types/fulfillment-line.type";
import {LocationType} from "../../../commons/types/location.type";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OrdersService} from "../../../orders/services/orders-service.service";
import {OmsDialogService} from "../../services/oms-dialog-service.service";
import {OmsOrdersAlertsService} from "../../services/oms-orders-alerts.service";
import {OmsRequestsService} from "../../services/oms-requests.service";
import {OmsService} from "../../services/oms-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {PricePlanBundleRequestsService} from "../../../price-plan/services/price-plan-bundle-requests.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {getFulfillmentLineItems} from "../../../fulfillment/utils/fulfillment-line-items.util";

export class OmsOrderEditViewComponent implements IController {

  order: any;

  public siteInfo: any;
  public sections: any;
  public orderCopy: any;
  public priceOfferCopy: any;
  public pickupDepotIds: string[];
  public accountBranchIds: string[];
  public addMarkerPurpose: any;
  public dueTo: any;
  public submitting = false;
  public customAddressEnabled: boolean;
  public addMarker: any;
  public includePriceForOms: any;
  public pricePlanBundle: any;
  public priceOffer: any;
  public isPriceOfferEditMode: boolean;
  public isWeightInTotal: boolean;
  public proxyProviderType: any;
  public callContactUsingProxyByDefaultValue: boolean;
  public fulfillmentLineType: typeof FulfillmentLineType = FulfillmentLineType;
  public defaultProgram: any;
  public isInvalidForm: boolean;
  public isReferenceIdsMandatory: boolean;
  public orderAccount: any;
  public isOmsPackageDimensionMandatory: boolean;
  public canCreateTag: boolean;
  public isOrderEditable: boolean;


  constructor(private bringozLoaderService: BringozLoaderService, private $state, private $deliveries, private IAMPermissions, private ordersService: OrdersService,
              private omsRequestsService: OmsRequestsService, private omsOrdersAlertsService: OmsOrdersAlertsService, private moment, private pricePlanBundleRequestsService: PricePlanBundleRequestsService,
              private omsService: OmsService, private commonsAlertsService: CommonsAlertsService, private omsDialogService: OmsDialogService, private $log, private $q: IQService, private $timeout: ITimeoutService,
              private billingOrderService: BillingOrderService, private splitService: SplitService, private siteContextService: SiteContextService, private commonsDialogService: CommonsDialogService) {
    this.dueTo = moment().endOf('day').set({'minute': 30, 'second': 0, 'millisecond': 0}).toDate();
  }

  $onInit() {
    this.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');
    this.orderAccount = this.order.accountReference;
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.includePriceForOms = this.siteInfo.priceDetailsForOmsOrder;
    this.callContactUsingProxyByDefaultValue = this.siteInfo.callContactUsingProxyByDefault;
    this.proxyProviderType = this.siteInfo.proxyProviderType;
    this.isPriceOfferEditMode = false;
    this.addMarkerPurpose = undefined;
    this.customAddressEnabled = false;
    this.addMarker = {enabled: false};
    this.isOmsPackageDimensionMandatory = this.splitService.getIsOmsPackageDimensionMandatory();
    this.isWeightInTotal = this.splitService.getOmsPackageTotalWeightIndication();
    this.isReferenceIdsMandatory = this.splitService.isReferenceIdsMandatory();

    this.isOrderEditable = true;
    const orderEditStatus = this.omsService.checkOrderEditStatus(this.order.omsEditableStatus);

    const siteMetaDataSettings = this.splitService.getOmsMetadataSettings();

    this.order.metaData?.forEach((metaData, index) => {
      const siteMetaData = siteMetaDataSettings?.find((m) => m.key === metaData.key);
      if (!!siteMetaData) {
        this.order.metaData[index] = {...metaData, title: siteMetaData.title};
      }
    })
    if (!orderEditStatus.isEditable) {
      this.isOrderEditable = false;
      this.omsDialogService.blockedOrderEditReasonsList(orderEditStatus.reasons);
    }

  }


  onAccountSelect(account: AccountModel) {
    const orderCopy = angular.copy(this.order);

    this.orderAccount = account;

    orderCopy.accountId = _.get(account, 'id');

    this.pickupDepotIds = _.get(account, 'depotIds');
    this.accountBranchIds = _.get(account, 'branchIds');

    this.order = orderCopy;

  }

  onOpenAddLineMenu($mdMenu, ev) {
    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }


  onLocationButtonToggle() {
    this.addMarker.enabled = !this.addMarker.enabled;
  }

  onTogglePriceOfferEditMode() {
    this.isPriceOfferEditMode = !this.isPriceOfferEditMode;
    this.orderCopy = this.isPriceOfferEditMode ? angular.copy(this.order) : undefined;
    this.priceOfferCopy = this.isPriceOfferEditMode ? angular.copy(this.priceOffer) : undefined;
  }

  onToggleCustomAddress(purpose) {
    this.addMarkerPurpose = _.isEqual(this.addMarkerPurpose, purpose) ? undefined : purpose;
  }

  //Maybe should remove it
  onDateChange(date) {
    this.order.dueTo = moment(date).valueOf();
  }

  //maybe should remove it
  onTimeChange(date) {
    this.order.dueTo = date;
  }

  onBackToOrderView() {
    this.priceOffer = undefined;
    this.isPriceOfferEditMode = false;
    this.orderCopy = undefined;
    this.priceOfferCopy = undefined;
  }

  onReferenceIdsChange(referenceIds) {
    this.order.referenceIds = referenceIds;
  }

  onTagsChange(tagNames) {
    this.order.tags = tagNames;
  }

  // onPricePlanChange(fulfillmentLine) {
  //   this.order.itemLines = _.filter(this.order.itemLines, item => {
  //     return !_.includes(fulfillmentLine.itemIds, item.id);
  //   })
  //   const fulfillmentLinesCopy = angular.copy(this.order.fulfillmentLines);
  //   const fulfillmentLineIndex = _.findIndex(this.order.fulfillmentLines, (item: any) => {
  //     return item.id === fulfillmentLine.id;
  //   });
  //   fulfillmentLinesCopy[fulfillmentLineIndex].itemIds = [];
  //   this.order.fulfillmentLines = fulfillmentLinesCopy;
  // }

  updatePriceOffer(updatedPriceOffer) {
    this.priceOfferCopy = updatedPriceOffer;
  }

  onAddLine(lineType, fulfillmentLine) {
    let newFulfillmentLine = {
      id: this.order.fulfillmentLines.length + 1,
      type: lineType,
      price: undefined,
      packageList: [],
      programType: undefined,
      programName: undefined,
      itemIds: [],
      blockedByLines: [],
      pickupTask: {
        purpose: "Pickup",
        notBefore: undefined,
        notAfter: undefined,
        contact: {
          name: undefined,
          businessName: undefined,
          phoneNo: undefined
        },
        location: {
          id: undefined,
          locationType: "CUSTOM",
          address: {
            entryId: undefined, //depotId/customerId
          }
        },
        useProxyCall: this.callContactUsingProxyByDefaultValue,
        schedulingRequired: false,
        obligateTimeWindow: false
      },
      destinationTask: {
        purpose: "Dropoff",
        notBefore: undefined,
        notAfter: undefined,
        contact: {},
        location: {
          locationType: "CUSTOM",
          address: {
            entryId: undefined, //depotId/customerId
          }
        },
        useProxyCall: this.callContactUsingProxyByDefaultValue,
        schedulingRequired: false,
        obligateTimeWindow: false
      }
    }
    if (lineType === this.fulfillmentLineType.Delivery) {
      newFulfillmentLine.pickupTask.contact.name = _.get(this.orderAccount, 'name');
      newFulfillmentLine.pickupTask.contact.businessName = _.get(this.orderAccount, 'name');
      newFulfillmentLine.pickupTask.contact.phoneNo = _.get(this.orderAccount, 'phoneNumber');
      newFulfillmentLine.pickupTask.location.id = _.get(this.orderAccount, 'id');
      newFulfillmentLine.pickupTask.location.locationType = this.orderAccount ? LocationType.ACCOUNT : undefined;
      newFulfillmentLine.pickupTask.location.address = _.get(this.orderAccount, 'address', {});
    }
    if (lineType === this.fulfillmentLineType.ReturnDelivery) {
      newFulfillmentLine.blockedByLines.push(fulfillmentLine.id);
      newFulfillmentLine.pickupTask = angular.copy(fulfillmentLine.destinationTask);
      newFulfillmentLine.pickupTask.purpose = 'Pickup';
      newFulfillmentLine.destinationTask = angular.copy(fulfillmentLine.pickupTask);
      newFulfillmentLine.destinationTask.purpose = 'Dropoff';
      newFulfillmentLine.destinationTask.notBefore = newFulfillmentLine.pickupTask.notBefore;
      newFulfillmentLine.destinationTask.notAfter = newFulfillmentLine.pickupTask.notAfter;
      newFulfillmentLine.destinationTask.schedulingRequired = newFulfillmentLine.pickupTask.schedulingRequired;
      newFulfillmentLine.programType = angular.copy(fulfillmentLine.programType);
      newFulfillmentLine.programName = angular.copy(fulfillmentLine.programName);

    }
    if (lineType === this.fulfillmentLineType.Operation) {
      newFulfillmentLine.blockedByLines.push(fulfillmentLine.id);
      _.unset(newFulfillmentLine, 'pickupTask');
      newFulfillmentLine.programType = angular.copy(fulfillmentLine.programType);
      newFulfillmentLine.programName = angular.copy(fulfillmentLine.programName);
      newFulfillmentLine.destinationTask = angular.copy(fulfillmentLine.destinationTask);
      newFulfillmentLine.destinationTask.purpose = "Operation";
    }
    _.forEach(getFulfillmentLineItems(fulfillmentLine, this.order.itemLines), item => {
      let newItem;
      newItem = angular.copy(item);
      const newItemId = 'line_' + newFulfillmentLine.id + '_' + (newFulfillmentLine?.itemIds ? newFulfillmentLine.itemIds.length : '0');
      newItem.id = newItemId;
      newFulfillmentLine.itemIds.push(newItemId);
      this.order.itemLines.push(newItem);
    })
    this.order.fulfillmentLines.push(newFulfillmentLine);
  }

  onRemoveLine(fulfillmentLineId) {
    const fulfillmentLineIndex = _.findIndex(this.order.fulfillmentLines, (item: any) => {
      return item.id === fulfillmentLineId;
    })
    this.order.itemLines = _.filter(this.order.itemLines, item => {
      return !_.includes(this.order.fulfillmentLines[fulfillmentLineIndex].itemIds, item.id);
    })
    this.order.fulfillmentLines.splice(fulfillmentLineIndex, 1);
  }

  onAddPackages(items, fulfillmentLineId) {
    this.order.itemLines = this.order.itemLines.concat(angular.copy(items));

    this.$timeout(() => {
      const lineAddPackageSection = document.getElementById(`add-package-${fulfillmentLineId}`);
      lineAddPackageSection.scrollIntoView({behavior: "smooth", block: "end"});

    }, 1);
  }

  onRemovePackage(itemId) {
    this.order.itemLines = _.filter(this.order.itemLines, (i) => {
      return i.id !== itemId;
    })
  }

  onPackageChange(packageItem) {
    const orderCopy = angular.copy(this.order);
    const packageItemIndex = _.findIndex(orderCopy.itemLines, (i: any) => {
      return i.id === packageItem.id;
    })
    orderCopy.itemLines[packageItemIndex] = packageItem;
    this.order = orderCopy;
  }

  onCancel(fulfillmentId) {
    // this.$state.go('order.info', {id: this.order.id}, {notify: true, reload: false});
    this.$state.go('fulfillment-lines', {
      fulfillmentId: this.order.fulfillmentId,
    }, {notify: true, reload: true});
  }

  updateOrder(updatedOrder) {
    this.orderCopy = updatedOrder;
  }

  onSaveDraft() {
    this.submitting = true;
    this.omsRequestsService.createOrder(this.order, true)
      .then((createdOrder) => {
        this.omsOrdersAlertsService.createDraftSuccess();
        this.$state.go('order.info', {id: createdOrder.id}, {notify: true, reload: false});
      })
      .catch(() => {
        this.omsOrdersAlertsService.createDraftError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
        this.submitting = false;
      });
  }

  onUpdate(form) {
    this.isInvalidForm = false;

    this.$timeout(0).then(() => {
      form.$setSubmitted(true);
      _.forEach(this.order.fulfillmentLines, (fulfillmentLine, index) => {
        const lineForm = `line_${index}`;
        form[lineForm].$setSubmitted();

        if (!!form[lineForm].Origin) {
          form[lineForm].Origin.$setSubmitted();
        }

        if (!!form[lineForm].Destination) {
          form[lineForm].Destination.$setSubmitted();
        }
      });

      if (form.$valid) {

        let isValidServiceArea;

        this.omsService.validateOmsOrderServiceAreas(this.order)
          .then((isValid) => {
            isValidServiceArea = isValid;
            const isPricingEnabled = (this.IAMPermissions.hasPermission('priceplan.list') && !!this.includePriceForOms);
            return !!isPricingEnabled ? this.omsService.getPricingOffer(this.order) : this.$q.when();
          })
          .then((priceOffer) => {
            this.priceOffer = priceOffer;
            if (!priceOffer) {
              this._updateOrder(this.order);
            } else if (!isValidServiceArea) {
              this.omsDialogService.validateServiceAreas()
                .then((editPrice) => {
                  this.isPriceOfferEditMode = editPrice;
                  if (!!editPrice) {
                    this.orderCopy = angular.copy(this.order);
                    this.priceOfferCopy = angular.copy(priceOffer);
                  }
                })
            }
          })
      } else {
        this.commonsAlertsService.formInvalidInfo();
        this.isInvalidForm = true;
      }
    })
  }

  onSubmitPriceOffer(form, doDispatch) {
    form.$setSubmitted(true);
    if (form.$valid) {
      if (this.isPriceOfferEditMode) {
        this._updateOrder(this.orderCopy, doDispatch, this.priceOfferCopy);
      } else {
        this._updateOrder(this.order, doDispatch, this.priceOffer);
      }
    } else {
      this.commonsAlertsService.formInvalidInfo();
    }
  }


  // private _setAccountProgram(accountId) {
  //
  //   this.pricePlanBundleRequestsService.getDefaultProgramTypeByServiceType(accountId, 'Delivery')
  //     .then((defaultProgram) => {
  //
  //       this.pricePlanBundleRequestsService.getPricePlanBundleByAccountId(accountId)
  //         .then((pricePlanBundle) => {
  //           this.pricePlanBundle = pricePlanBundle;
  //           this.defaultProgram = _.find(pricePlanBundle.entryList, (e) => {
  //             return e.id === defaultProgram.id;
  //           })
  //         })
  //
  //     })
  // }

  private _updateOrder(order, doDispatch?, priceOffer?) {
    this.bringozLoaderService.on();
    this.submitting = true;
    let updatedOrderRef;
    const orderCopy = angular.copy(order);
    orderCopy.metaData = _.chain(orderCopy.metaData)
      .filter(item => {
        return item.value;
      })
      .map(item => {
        return {
          key: item.key,
          value: item.value
        }
      })
      .value();
    this.omsRequestsService.updateOrder(order.id, order)
      .then((updatedOrder) => {
        this.omsOrdersAlertsService.updateSuccess();
        updatedOrderRef = updatedOrder;
        const priceOfferHasInitialPriceDetailLines = _.get(priceOffer, 'pricingDataInfos[0].priceDetails.initialPriceDetailLines');
        return (!!priceOffer && priceOfferHasInitialPriceDetailLines) ?
          this.billingOrderService.updatePrice(updatedOrder.billingOrderId, priceOffer) : this.$q.when();
      })
      .then(() => {
        // this.$state.go('order.info', {
        //   id: updatedOrderRef.id,
        //   doDispatch: doDispatch,
        //   autoDispatch: this.siteInfo.allowAutoDispatch
        // }, {notify: true, reload: true});
        this.$state.go('fulfillment-lines', {
          fulfillmentId: updatedOrderRef.fulfillmentId,
          doDispatch: doDispatch,
        }, {notify: true, reload: false});
      })
      .catch((error) => {
        if (error.code === 400411 || error.code === 40013) {
          if (error.code === 40013) {
            this.omsOrdersAlertsService.updateInfo(error);
          }
          this.$state.go('order.info', {
            id: order.id,
            doDispatch: doDispatch,
            autoDispatch: this.siteInfo.allowAutoDispatch
          }, {notify: true, reload: true});
        } else {
          this.omsOrdersAlertsService.updateError(error);
        }
      })
      .finally(() => {
        this.bringozLoaderService.off();
        this.submitting = false;
      });
  }


}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderEditView', {
    bindings: {
      order: '<'
    },
    template: require('./oms-order-edit-view.html').default,
    controller: OmsOrderEditViewComponent
  });
